import "core-js/modules/es.array.index-of";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { getBackpackDetail, yjBagDesc } from "@/api/dataAll/backPack";
import watchBackPackDetails from "./components/watchBackPackDetails";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "backPackDetail",
  mixins: [tabulation, gmToolNewPage, gmTool],
  components: {
    watchBackPackDetails: watchBackPackDetails
  },
  data: function data() {
    return {
      searchData: {
        server_id: "",
        device_id: "",
        user_id: "",
        role_id: "",
        name: "",
        desc_name: "",
        desc_kind: "",
        page: 1,
        page_size: 10
      },
      // currentPage: 1,
      // pageSize: 10,
      tableData: [],
      // 表格数据
      tableCopyTableList: [],
      // 表格copy数据b
      isgetdataCurrency: true,
      adPlacementSingleChoice: true,
      total: 0,
      serverList: [],
      itemDetail: {},
      isNeedDate: false
    };
  },
  created: function created() {
    this.isNeedDate = this.rawData.game_mark.indexOf('yjfm') == -1;

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  mounted: function mounted() {},
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      this.searchData.page = e;
      this.searchData.kind = 1;
      this.searchData.starttime = this.value2[0];
      this.searchData.endtime = this.value2[1];
      var searchData = JSON.parse(JSON.stringify(this.searchData));
      searchData.ad_placement = searchData.ad_placement == "valuets" ? [""] : searchData.ad_placement;
      searchData.server_id = this.paramsData.server_id;

      if (this.rawData.game_mark.indexOf('yjfm') > -1) {
        if (!searchData.server_id) {
          this.$message.error(this.$t('pleaseSelectServer'));
          return;
        }

        searchData.env_id = this.paramsData.env_id;

        if (!searchData.role_id && !searchData.name) {
          this.$message.error(this.$t('pleaseInputRoleId'));
          return;
        }

        if (!searchData.desc_name) {
          this.$message.error(this.$t('pleaseInputItemId'));
          return;
        }
      }

      this.reqLoading = true;
      var reqFn = this.rawData.game_mark.indexOf('yjfm') == -1 ? getBackpackDetail : yjBagDesc;
      reqFn(searchData).then(function (res) {
        console.log(res);

        if (res.status == 200) {
          var list = ["game", "platform", "channel", "pkg", "ad_channel", "ad_placement"];
          _this.tableData = res.data.data.length ? _this.$utils.dataConversion(res.data.data, list) : [];
          _this.total = res.data.total ? parseInt(res.data.total) : 0;

          if (res.data.item_detail) {
            _this.itemDetail = res.data.item_detail;
          } // this.currentPage = 1;
          // this.tableCopyTableList = JSON.parse(JSON.stringify(this.tableData));
          // this.tableData = this.currentChangePage(this.pageSize, this.currentPage);


          _this.$nextTick(function () {
            _this.getTableRight();
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.searchClick(1);
    },
    getServer: function getServer() {
      var _this2 = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this2.serverList = res.data;
        }
      });
    },
    exportdata: function exportdata() {
      var _this3 = this;

      getBackpackDetail(_objectSpread(_objectSpread({}, this.searchData), {}, {
        page_size: -1
      })).then(function (res) {
        if (res.status == 200) {
          var columns = [{
            label: _this3.$t('game'),
            prop: "game_reveal"
          }, {
            label: _this3.$t('platform'),
            prop: "platform_reveal"
          }, {
            label: _this3.$t('channel'),
            prop: "channel_reveal"
          }, {
            label: _this3.$t('pkg'),
            prop: "pkg_reveal"
          }, {
            label: _this3.$t('adPlatform'),
            prop: "ad_channel_reveal"
          }, {
            label: _this3.$t('adPlacement'),
            prop: "ad_placement_reveal"
          }, {
            label: _this3.$t('serverId'),
            prop: "server_id"
          }, {
            label: _this3.$t('deviceNo'),
            prop: "device_id"
          }, {
            label: _this3.$t('accountLabel'),
            prop: "user_id"
          }, {
            label: _this3.$t('roleId'),
            prop: "role_id"
          }, {
            label: _this3.$t('roleName'),
            prop: "role_name"
          } // { label: "物品类型", prop: "desc_kind" },
          // { label: "物品名称", prop: "desc_name" },
          // { label: "物品数量", prop: "num" },
          ];
          var list = ["game", "platform", "channel", "pkg", "ad_channel", "ad_placement"];
          var data = res.data.data.length ? _this3.$utils.dataConversion(res.data.data, list) : []; // let data = res.data.data;

          _this3.$export.excel({
            columns: columns,
            data: data,
            title: _this3.$route.meta.title
          });
        }
      });
    },
    headerZh: function headerZh(index, nIndex) {
      var k = parseInt(index / 13);
      var letterTable = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
      var num = k > 0 ? letterTable[k - 1] : "";

      if (k < 1) {
        if (nIndex == 0) {
          num = num + letterTable[k <= 1 ? index * 2 : index];
        } else {
          num = num + letterTable[k <= 1 ? index * 2 + 1 : index + 1];
        }
      } else {
        if (nIndex == 0) {
          num = num + letterTable[index % 13 * 2];
        } else {
          num = num + letterTable[index % 13 * 2 + 1];
        }
      }

      return num + "1";
    },
    handleSource: function handleSource(row) {
      if (this.rawData.game_mark.indexOf('yjfm') == -1) {
        this.$refs.watchBackPackDetails.init(row);
      } else {
        this.$refs.watchBackPackDetails.init(JSON.stringify(this.itemDetail));
      }
    }
  }
};